var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "48", height: "48", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#svg2983831033a)" },
      React.createElement("path", { d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z", fill: "#F0F0F0" }),
      React.createElement("path", { d: "M48 24c0-9.515-5.537-17.737-13.565-21.619V45.62C42.463 41.736 48 33.514 48 24zM0 24c0 9.515 5.537 17.737 13.565 21.619V2.38C5.537 6.263 0 14.485 0 24zM28.174 27.13l4.174-2.087L30.26 24v-2.087L26.087 24l2.087-4.174h-2.087L24 16.696l-2.087 3.13h-2.087L21.913 24l-4.174-2.087V24l-2.087 1.043 4.174 2.087-1.043 2.087h4.174v3.13h2.086v-3.13h4.174l-1.043-2.087z", fill: "#D80027" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "svg2983831033a" },
        React.createElement("path", { fill: "#fff", d: "M0 0h48v48H0z" })
      )
    )
  );
});